/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShiftFilter } from '../../models/shift-filter';

export interface GetShiftFilters$Params {
  workCenterId: number;
}

export function getShiftFilters(http: HttpClient, rootUrl: string, params: GetShiftFilters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShiftFilter>>> {
  const rb = new RequestBuilder(rootUrl, getShiftFilters.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ShiftFilter>>;
    })
  );
}

getShiftFilters.PATH = '/api/v1/MachineSchedule/{workCenterId}/ShiftFilters';
